import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FloatButton } from 'antd';
import { QuestionCircleOutlined, YoutubeOutlined } from '@ant-design/icons';

/**
 * FloatingButton Component
 * 페이지 우측 하단에 고정된 플로팅 버튼 그룹입니다.
 * - 최상단 이동 (BackTop)
 * - YouTube 채널 이동
 * - 문의하기 페이지 이동
 * 
 * @param {object} style - 추가적인 스타일 객체 (예: { right: 24 })
 */
const FloatingButton = ({ style }) => {
  const navigate = useNavigate();

  return (
    <FloatButton.Group shape="circle" style={style}>
      <FloatButton.BackTop visibilityHeight={0} />
      <FloatButton
        onClick={() => {
          window.open(
            'https://youtube.com/channel/UCQ1KeVSwHwJgsDcz_UQFDIw',
            '_blank',
            'noopener, noreferrer'
          );
        }}
        icon={<YoutubeOutlined style={{ color: '#ff0000' }} />}
      />
      <FloatButton
        type="primary"
        onClick={() => {
          navigate('/contact');
        }}
        icon={<QuestionCircleOutlined />}
      />
    </FloatButton.Group>
  );
};

export default FloatingButton;
